/* eslint-env node */

const path = require(`path`);

const IRON_APPS_DIR = `iron/apps`;
const IRON_APPS_INFO = require(`./spa-apps.json`);
const BASE_APPS = [`common`];

const IRON_APPS = Object.keys(IRON_APPS_INFO);

const EXCLUDE_TEST_APPS = [`admin-org-settings`, `events`, `flows`, `funnels`, `home`, `retention`];

const ALL_APPS = [...BASE_APPS, ...IRON_APPS].filter((app) => !EXCLUDE_TEST_APPS.includes(app));

function appDir(app) {
  return BASE_APPS.includes(app) ? path.join(`iron`, app) : path.join(IRON_APPS_DIR, app);
}

exports.IRON_APPS_INFO = IRON_APPS_INFO;
// ALL_APPS is only used in dagger to determine test suites
exports.ALL_APPS = ALL_APPS;
exports.appDir = appDir;
